import { trim } from 'lodash';
import { COMMANDS, COMPONENT_ATTR_EDITING_ENABLED } from './constants';

export const enableEditableFieldCommandsOnRestrictedMode = plugins => {
	if ( plugins.has( 'RestrictedEditingModeEditing' ) ) {
		plugins.get( 'RestrictedEditingModeEditing' ).enableCommand( COMMANDS.GET_CONTENT );
		plugins.get( 'RestrictedEditingModeEditing' ).enableCommand( COMMANDS.SET_CONTENT );
		plugins.get( 'RestrictedEditingModeEditing' ).enableCommand( COMMANDS.SET_IS_UPDATING );
		plugins.get( 'RestrictedEditingModeEditing' ).enableCommand( COMMANDS.DIFF );
		plugins.get( 'RestrictedEditingModeEditing' ).enableCommand( COMMANDS.DIFF_BULK );
		plugins.get( 'RestrictedEditingModeEditing' ).enableCommand( COMMANDS.ENABLED );
	}
};

export const getAttributesFromEditableFieldViewElement = viewElement => {
	let id = '';
	let name = '';
	let updating = false;
	let newValue = false;
	let canReview = false;
	let enabled = true;
	if ( viewElement ) {
		id = viewElement.getAttribute( 'data-id' );
		name = viewElement.getAttribute( 'data-name' );
		updating = viewElement.getAttribute( 'data-updating' ) === true || viewElement.getAttribute( 'data-updating' ) === 'true';
		newValue = viewElement.getAttribute( 'data-new-value' );
		enabled = viewElement.getAttribute( COMPONENT_ATTR_EDITING_ENABLED );
		canReview = viewElement.getAttribute( 'data-can-review' ) !== 'false' &&
		viewElement.getAttribute( 'data-can-review' ) !== undefined ? true : undefined;
	}
	return { id, name, updating, newValue, canReview, enabled };
};

export function findDescendant( modelElement, predicate ) {
	const elements = [];
	if ( predicate( modelElement ) ) {
		return [ modelElement ];
	}
	if ( modelElement.getChildren ) {
		for ( const child of modelElement.getChildren() ) {
			const found = findDescendant( child, predicate );
			if ( found.length > 0 ) {
				elements.push( ...found );
			}
		}
	}
	return elements;
}

export function getSelectedText( editor ) {
	const selection = editor.model.document.selection.getFirstRange();
	if ( !selection ) {
		return '';
	}
	const selectionItems = selection.getItems();
	let selectedText = '';

	for ( const item of selectionItems ) {
		if ( item.data ) {
			selectedText += item.data;
		}
	}

	return trim( selectedText );
}

export function debounce( func, timeout = 300 ) {
	let timer;
	return ( ...args ) => {
		// eslint-disable-next-line no-undef
		clearTimeout( timer );
		// eslint-disable-next-line no-undef
		timer = setTimeout( () => {
			func.apply( this, args );
		}, timeout );
	};
}

export function getRandomID() {
	const randomID = Math.floor( Math.random() * 10000 );

	return `${ randomID }`;
}
